import xhr from 'xhr';

export default async function getStudent(data) {
  const res = await xhr(`/students/${data.id}?populate=user`);
  const res2 = await xhr(`/program-types/student/${data.id}`);

  return { student: res.data.data, programTypes: res2.data };
}
